export default {"src":"/_next/static/media/excedentes.cfc3d774.svg","height":120,"width":131};